import React, { useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import TagManagement from './TagManagement';
import ContentManagement from './ContentManagement';
import TrainingQuestionManagement from './TrainingQuestionManagement';
import { Tag, FileText, BrainCircuit } from 'lucide-react';

type Tab = 'tags' | 'contents' | 'questions';

const ContentManagementPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('contents');

  const tabs = [
    { id: 'contents', name: '内容管理', icon: FileText },
    { id: 'tags', name: '标签管理', icon: Tag },
    { id: 'questions', name: '题目管理', icon: BrainCircuit },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'tags':
        return <TagManagement />;
      case 'contents':
        return <ContentManagement />;
      case 'questions':
        return <TrainingQuestionManagement />;
      default:
        return null;
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">内容管理中心</h1>
          <p className="text-lg text-gray-600">
            在这里统一管理系统的内容、标签和训练题目，构建知识库的核心。
          </p>
        </div>

        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-6" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id as Tab)}
                className={`
                  ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                  group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors
                `}
              >
                <tab.icon className="-ml-0.5 mr-2 h-5 w-5" />
                <span>{tab.name}</span>
              </button>
            ))}
          </nav>
        </div>

        <div>{renderContent()}</div>
      </div>
    </AdminLayout>
  );
};

export default ContentManagementPage;